import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newOrders: localStorage.getItem("newOrders")
    ? JSON.parse(localStorage.getItem("newOrders"))
    : [],
};

const newOrdersSlice = createSlice({
  name: "newOrders",
  initialState,
  reducers: {
    setNewOrders: (state, action) => {
      state.newOrders = action.payload;
      localStorage.setItem("newOrders", JSON.stringify(action.payload));
    },
    removeNewOrders: (state, action) => {
      //state.users = [];
      state.newOrders = [];
      localStorage.removeItem("newOrders");
    },
  },
});

export const { setNewOrders, removeNewOrders } = newOrdersSlice.actions;

export default newOrdersSlice.reducer;
